import React, { Fragment } from 'react'
import CustomSelect from './CustomSelect'
import { useTranslation } from 'react-i18next'
import PhotosListItemComponent from './PhotosListItemComponent'

const PhotosListComponent = ({
  itemKey,
  numberOfPhotos,
  onChangeNumberOfPhotos,
  maximumNumberOfPhotos,
  disableItems,
  photosList,
  onChangeItemValue,
  selectedMoreThanOne,
  onClearTitle
}) => {
  const { t } = useTranslation()
  return (
    <Fragment>
      <CustomSelect
        nonSortedOptions
        key={itemKey}
        name={itemKey}
        value={numberOfPhotos}
        onChange={onChangeNumberOfPhotos}
        title={t('form_builder.elements.number_of_photos')}
        options={new Array(maximumNumberOfPhotos)
          .fill(1)
          .map((_, idx) => idx + 1)}
        disabled={disableItems}
      />
      {photosList.map((item, index) => (
        <PhotosListItemComponent
          disableItems={disableItems}
          onClearTitle={onClearTitle}
          selectedMoreThanOne={selectedMoreThanOne}
          key={index}
          item={item}
          index={index}
          onChangeItemValue={onChangeItemValue}
        />
      ))}
    </Fragment>
  )
}

export default PhotosListComponent
